import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";

const SideContentTemplate = ({
  id,
  classNames,
  backgroundImg,
  backgroundColor,
  headerHTML,
  headerClassNames,
  contentHTML,
  contentClassNames,
  signupBtnLabel,
  signupBtnLinkOverride,
  signupBtnClassNames,
  imgURL,
  imgMaxWidth,
  isImgRotated,
  isImgHiddenOnMobile,
  isContentReversed,
  isContentCentered,
  isPartialCentered,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <div
      id={id}
      className={cx(
        classNames,
        "content-template side-content-template",
        `bg-${backgroundImg}-img`,
        `bg-color-${backgroundColor}`,
        {
          "with-bg-img": backgroundImg !== "none",
        }
      )}
    >
      <div
        className={cx("container grid-container", {
          reverse: isContentReversed,
        })}
      >
        {imgURL && (
          <div
            className={cx("partial-image w-100 h-auto text-center", {
              "grid-col-12 grid-col-lg-6": !isPartialCentered,
              "partial--centered": isPartialCentered,
              "mobile-none": isImgHiddenOnMobile,
            })}
          >
            <img
              src={imgURL}
              alt=""
              className={cx({ rotate: isImgRotated })}
              style={{ maxWidth: `${imgMaxWidth}px` }}
              loading="lazy"
            />
          </div>
        )}
        <div
          className={cx("partial-content my-5 align-self-center", {
            "grid-col-12 grid-col-lg-6": !isPartialCentered,
            "partial--centered": isPartialCentered,
            "text-center": isContentCentered,
          })}
        >
          {headerHTML && (
            <h2
              className={`header ${headerClassNames}`}
              dangerouslySetInnerHTML={{
                __html: headerHTML,
              }}
            />
          )}
          {contentHTML && (
            <div
              className={`content ${contentClassNames}`}
              dangerouslySetInnerHTML={{
                __html: contentHTML,
              }}
            />
          )}
          {signupBtnLabel && (
            <a
              className={cx("button mt-5", signupBtnClassNames)}
              href={
                signupBtnLinkOverride ||
                `${t("common.exchangeLink")}/accounts/sign-in`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {signupBtnLabel}
            </a>
          )}
          {children && <div className="mt-4">{children}</div>}
        </div>
      </div>
    </div>
  );
};

SideContentTemplate.propTypes = {
  classNames: PropTypes.string,
  backgroundImg: PropTypes.oneOf([
    "none",
    "primary",
    "secondary",
    "invest-anywhere-anytime",
    "get-on-board",
  ]),
  backgroundColor: PropTypes.oneOf(["light", "grey", "blue"]),
  headerHTML: PropTypes.any,
  headerClassNames: PropTypes.string,
  contentHTML: PropTypes.any,
  contentClassNames: PropTypes.string,
  signupBtnLabel: PropTypes.string,
  signupBtnClassNames: PropTypes.string,
  signupBtnLinkOverride: PropTypes.string,
  imgURL: PropTypes.string,
  imgMaxWidth: PropTypes.number,
  isImgRotated: PropTypes.bool,
  isImgHiddenOnMobile: PropTypes.bool,
  isContentReversed: PropTypes.bool,
  isContentCentered: PropTypes.bool,
  isPartialCentered: PropTypes.bool,
};

SideContentTemplate.defaultProps = {
  classNames: "",
  backgroundImg: "none",
  backgroundColor: "light",
  headerClassNames: "",
  contentClassNames: "",
  signupBtnClassNames: "button-primary button-rounded",
  isImgRotated: false,
  isImgHiddenOnMobile: true,
  isContentReversed: false,
  isContentCentered: false,
  isPartialCentered: false,
};

export default SideContentTemplate;
